import React from "react";
import { Text } from "components";

const timeOfDay = () => {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
};

/** Plural helper: 1 → "1 draft", 3 → "3 drafts". */
const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

/** One-sentence summary of the collection, derived from counts (PRD §4.3). */
const summarize = ({ ready = 0, drafts = 0, inProgress = 0, played = 0, all = 0 }) => {
  const parts = [];
  if (inProgress) parts.push(`${plural(inProgress, "game")} in progress`);
  if (ready) parts.push(`${ready} ready to launch`);
  if (drafts) parts.push(`${plural(drafts, "draft")} in the works`);

  if (parts.length === 0) {
    if (played > 0) return "All your games are wrapped — time to build the next one.";
    return "Ready when you are — let's build your first game.";
  }
  if (parts.length === 1) return `You have ${parts[0]}.`;
  const last = parts.pop();
  return `You have ${parts.join(", ")} and ${last}.`;
};

const DashboardGreeting = ({ firstName, counts = {} }) => {
  const tiles = [
    { value: counts.all ?? 0, label: "games" },
    { value: counts.ready ?? 0, label: "ready" },
    { value: counts.played ?? 0, label: "played" },
  ];

  return (
    <div className="da-greet">
      <div className="da-greet-text">
        <Text variant="h2" className="da-greet-title">
          {timeOfDay()}, {firstName || "there"} <span aria-hidden="true">👋</span>
        </Text>
        <Text variant="body" tone="muted" className="da-greet-sub">
          {summarize(counts)}
        </Text>
      </div>
      <div className="da-greet-stats">
        {tiles.map((t) => (
          <div key={t.label} className="da-stat-tile">
            <div className="da-stat-num">{t.value}</div>
            <div className="da-stat-label">{t.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardGreeting;
